import React, { useEffect, useState, useMemo, createRef } from "react";
import TableWithDynamicPagination from "@components/table/table";
import DownLoad from "@components/table/download";
// import WellBeEMPIService from "@services/empiService.service";
import { map, sortBy, filter, isEmpty, get, toString , last} from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
// import MatchingMergedRecords from "./matchingMergedRecords/matchingMergdRecords";
import { formatDisplayDate, getClientName, getDateWithLocalTimeZone } from "@utils/helpers";
import "./GenericTableReport.scss";
// import Download from "@assets/blueDownloadIcon.svg";
import ReportService from "@services/report.service";
import { Button, DatePicker, Select, Spin } from "antd";

import CustomTooltip from "@pages/tool-tip";
import MillenniumLogo from "@assets/Millennium_Logo.png";
import moment from "moment";

import { FilterCountBtn } from "@components/filters/colFilters";
import { useGenericTableStore } from "@stores/useGenericTableStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useDropdowns, useNavigateToMemberdetails } from "@utils/customHooks";
import { dashBoardReportPageMapping, dateFormatConfig } from "@utils/constants";
import { GenericColumnConfig } from "./GenericColumnConfig";
import { ColConfigProvider, useColConfigContext } from "./useColConfig";
import Icon from "@assets/icon_config";
import ButtonGroup from "antd/lib/button/button-group";

const centerAlignedFormatTypes = ["CENTER", "COLORED", "DATE", "DATETIME"];

const GetRender = ({ value, record, item, reportTitle }: any) => {
  const { goToMemberDetails } = useNavigateToMemberdetails();

  const [loader, setLoader] = useState(false);
  const formatTypes = useMemo(() => {
    if (item.format_type) {
      return item.format_type?.split("$|");
    }
    return [];
  }, [item.format_type]);

  const className = useMemo(() => {
    let renderClass = "col";
    if (formatTypes.some((type: string) => type.includes("LINK"))) {
      renderClass += record.has_patient_access ? " col-link" : " col-disabled-link";
    }

    if (centerAlignedFormatTypes.some((type) => formatTypes.includes(type))) {
      renderClass += " col-center";
    }

    if (formatTypes.includes("LEFT")) {
      renderClass += " col-left";
    }

    if (formatTypes.includes("COLORED")) {
      renderClass += ` col-color-${record.hasOwnProperty(item.dataIndex + "_flag") ? record[item.dataIndex + "_flag"]?.toLowerCase() : (toString(value) || "")?.toLowerCase()?.split(" ").join("")}`;
    }
    return renderClass;
  }, [formatTypes, item, record, value]);

  const getValue = useMemo(() => {
    if (formatTypes.includes("DATETIME")) {
      return moment(value).isValid() ? formatDisplayDate(toString(value), "reminderDateActualFormat", "defaultDateFormatWithTime", false) : "--";
    } else if (formatTypes.includes("DATE")) {
      return moment(value).isValid() ? `${formatDisplayDate(value, "createDateFormat")}` : "--";
    } else {
      return value;
    }
  }, [formatTypes, value]);

  const onClickAction = React.useCallback(() => {
    console.log("GetRender.onClickAction");
    if (formatTypes.some((type: string) => type.includes("LINK")) && record.has_patient_access) {
      const pageToNavigate = formatTypes.find((type: string) => type.includes("LINK")).match(/LINK-(.+)/)[1];
      if (pageToNavigate === "MEMBERPROFILE") {
        goToMemberDetails({ condition: record.has_patient_access, patientId: record.patient_id, fromPage: `Report / ${reportTitle}`, setLoader });
      }
    }
  }, [formatTypes, goToMemberDetails, record.has_patient_access, record.patient_id, reportTitle]);

  return (
    <Spin spinning={loader} indicator={<HealthemSpinner />}>
      <div className={`${className}`} onClick={onClickAction}>
        <CustomTooltip toolTipvalue={getValue} />
      </div>
    </Spin>
  );
};

const CadenceReport = ({ selectedReport }: any) => {
  const [columnsNeedToShowInTable, setColumnsNeedToShowInTable] = useState<any>([]);
  const [columnLoading, setColumnLoading] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const filteredInfo = useGenericTableStore((state) => state.filteredInfo);
  const setFilteredInfo = useGenericTableStore((state) => state.setFilteredInfo);
  const topFilters = useGenericTableStore((state) => state.topFilters);
  const setTopFilters = useGenericTableStore((state) => state.settopFilters);
  const showFilters = useGenericTableStore((state) => state.showFilters);
  const setShowFilters = useGenericTableStore((state) => state.setShowFilters);

  const {getOptions, filterDropdowns} = useDropdowns();

  const {reportKey , reportTitle , reportLastUpdatedDate , reportPageName} = useMemo(() => {
    const reportKey = get(selectedReport, "value", '');
    const reportTitle = get(selectedReport, "title", '');
    const reportLastUpdatedDate = get(selectedReport, "lastUpdatedDate", '');
    const reportPageName = get(dashBoardReportPageMapping, get(selectedReport, "value", null), "");

    return {reportKey , reportTitle , reportLastUpdatedDate , reportPageName};
  } , [selectedReport]) 

  const handleFilteredInfo = (val : any) => {
    setFilteredInfo({[reportKey] : val})
  }
  
  const { toggleDrawer, tableConfigCallback, tableConfigData , setTableConfigData , getExpandableColumnTitle, expandColumn} = useColConfigContext();

  const fetchData = async (payload: any) => {
    console.log("GenericTableReport.fetchData");
    const _data = await axios
      .post(`${sessionService.getClient()?.appServiceUrl}/report/getReportTableData`, { ...payload, reportName: reportPageName },
      {
        params: {
          startDate: topFilters.startDate ? topFilters.startDate.format('YYYY-MM-DD') : 'null',
          endDate: topFilters.endDate ? topFilters.endDate.format('YYYY-MM-DD') : 'null',
        },
      })
      .then((v) => {
        return v?.data?.data;
      });

    return {
      totalCount: _data?.count,
      data: _data?.records,
    };
  };

  const getColumns = React.useCallback(() => {
    setColumnLoading(true);
    ReportService.getColumnsList(reportPageName).subscribe({
      next: (v) => {
        let _columnsNeedToShowInTable = filter(v.data.data?.columns, (item) => {
          return item.isDisplay === "Y";
        });
        setColumnLoading(false);
        let _columns = map(
          _columnsNeedToShowInTable.filter((col: any) => col.isDisplay === "Y"),
          (item) => {
            // if (!['patient_name', 'record_id', 'user_name'].includes(item.key)) {
            //   item.type = '';
            //   const _title = item.tableHeaderName || item.displayName
              
            //   item.title = <div style={{textAlign: 'center'}}>{_title}</div>
            // }
            if(get(item , 'subColumns.length' , 0) > 0) {
              item.subColumns.unshift({
                key: item.dataIndex,
                title: item.tableHeaderName,
                label: item.displayName,
                dataIndex: item.dataIndex,
                displayName: item.displayName,
                tableHeaderName: item.tableHeaderName,
                isSelected: true,
                type: item.type,
                dropdown_key: item.dropdown_key,
              });

              item.subColumns = item.subColumns.map((subItem: any) => {
                return {
                  ...subItem,
                  title: subItem.tableHeaderName,
                  label: subItem.displayName,
                  sequence: subItem.order,
                  width: 200,
                }
              })
            }

            const _parentTableHeaderName = get(last(item.subColumns), 'parentTableHeaderName' , item.displayName);
            
            return {
              ...item,
              title : get(item , 'subColumns.length' , 0) > 0 ? getExpandableColumnTitle(_parentTableHeaderName) : item.title,
              label: item.displayName,
              dataIndex: item.dataIndex,
              key: item.key,
              sequence: item.order,
              width: 200,
              ...((item.format_type || "").includes("FIXED") && { fixed: true }),
              render: (value: any, record: any) => {
                return <GetRender value={value} record={record} item={item} reportTitle={reportTitle} />;
              },
              isDraggable: (item.format_type || "").includes("FIXED") ? false : item.isDraggable,
              isSelected : ((item.format_type || "").includes("FIXED") ? true : item.isSelected)
            };
          }
        );
        _columns = sortBy(_columns, [
          // Sort by isDraggable in ascending order (false first, true later)
          "isDraggable",
          // Then sort by order to maintain the original order within each group
          "order",
        ]);
        filter(_columns, (item) => {
          return item.isDisplay === "Y";
        });
        setColumnsNeedToShowInTable(_columnsNeedToShowInTable);
        tableConfigCallback(_columns);
        setTableConfigData(_columns);
      },
      error: (e) => {
        console.log(e);
        setColumnLoading(false);
      },
    });
  }, [reportPageName, reportTitle, setTableConfigData, tableConfigCallback]);

  useEffect(() => {
    getColumns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedReport]);

  // const [topFilters, setTopFilters] = useState<any>({})

  function handleDownload({ filters = {}, sortByCol, sortType }: any) {
    console.log("GenericTableReport.handleDownload");
    setDownloadLoader(true);
    axios.post(`${sessionService.getClient()?.appServiceUrl}/report/downloadReport` , {
      reportName: reportPageName,
      columns: columnsNeedToShowInTable,
      sortByCol,
      sortType,
      filters
    }, 
  {
    params: {
      startDate: topFilters.startDate ? topFilters.startDate.format('YYYY-MM-DD') : 'null',
      endDate: topFilters.endDate ? topFilters.endDate.format('YYYY-MM-DD') : 'null',
    },
  }).then(
      v => {
        setDownloadLoader(false);
        if (v.data.status === "OK" && v.data.data.fileURL) window.open(v.data.data.fileURL, "_blank");
      }
    ).catch(e => {
      setDownloadLoader(false);
    });
  }
  
  const disabled =  false

  const wrapperRef = createRef<any>()

  return (
    <div className="cadence-report">
      <div className="generic-report">
        <div className="generic-report__header">
          <img src={MillenniumLogo} alt={"download"} />
          <span className="generic-report__header_title">{reportTitle}</span>
          <FilterCountBtn filteredInfo={filteredInfo[reportKey]} className={"generic-report__header__filter_btn"} showFilters={showFilters} setShowFilters={setShowFilters} />
        </div>
        {/* {columnsNeedToShowInTable.length > 0 ? <i style={{ marginRight: 8 }} className="btn-icon icon-settings clr-n125" onClick={() => toggleDrawer()} /> : <></>} */}
        <div className='generic-report__actions'>
          <DatePicker
            showTime={false}
            disabled={disabled}
            format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
            placeholder="Start Date"
            value={topFilters.startDate}
            onChange={(value: any) => {
              setTopFilters(
                {
                  ...topFilters,
                  startDate: value
                }
              )
            }}
            disabledDate={
              (date) => {
                if (topFilters?.endDate && date.isAfter(topFilters?.endDate)) {
                  return true
                }
                return false
              }
            }
          />
          <DatePicker
            showTime={false}
            disabled={disabled}
            format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
            value={topFilters.endDate}
            placeholder="End Date"
            onChange={(value: any) => {
              setTopFilters(
                {
                  ...topFilters,
                  endDate: value
                }
              )
            }}
            disabledDate={
              (date) => {
                if (topFilters?.startDate && date.isBefore(topFilters?.startDate)) {
                  return true
                }
                return false
              }
            }
          />
          <ButtonGroup size="middle" className="outcome__btn-group">
            {
              filterDropdowns?.CadenceReportOutcomeFilterLst?.map(
                (item: any, index: number) => {
                  return (
                    <Button
                      className={`outcome__btn-group__btn ${item.value === topFilters['outcome'] ? 'active' : ''}`}
                      key={item.value}
                      value={item.value}
                      onClick={
                        () => {
                          setTopFilters(
                            {
                              ...topFilters,
                              outcome: item.value
                            }
                          )
                        }
                      }
                    >
                      {item.label}
                    </Button>
                  )
                }
              )
            }
          </ButtonGroup>
          <DownLoad onClick={(data: any) => handleDownload(data)} className="generic-report__download" loader={downloadLoader} filteredInfo={filteredInfo[reportKey]}>
            <div className={`download auto-width ${disabled ? 'download-disabled' : ''}`}>
              <Icon name="report-download" colorOfBrand={disabled ? '#838EA0' : ''}/>
            </div>
          </DownLoad>
        </div>
      </div>
      <TableWithDynamicPagination
        condition={!isEmpty(reportPageName)}
        dependencyProps={[reportPageName, topFilters.startDate, topFilters.endDate]}
        className="ui-expandable-table"
        columns={tableConfigData.filter((item: any) => {
          return item.isSelected;
        })}
        handleFetchData={fetchData}
        perPageCount={10}
        columnOriginalList={columnsNeedToShowInTable}
        loading={columnLoading}
        message={`Report last updated on ${getDateWithLocalTimeZone(reportLastUpdatedDate)}`}
        filteredInfo={filteredInfo[reportKey]}
        setFilteredInfo={handleFilteredInfo}
        scrollProp = {{ y: window.innerHeight - 429 }}
      />
      <GenericColumnConfig
        filteredInfo={filteredInfo[reportKey]}
        columnListData={columnsNeedToShowInTable}
        getColumns={getColumns}
        reportName={reportPageName}
      />
    </div>
  );
};

const Wrapper: React.FC<any> = function (props) {
  return (
    <ColConfigProvider>
      <CadenceReport {...props} />
    </ColConfigProvider>
  );
};

export default Wrapper;
